<ion-card>
  <ion-card-header>
    <ion-toolbar>
      <div class="c3-flex ion-justify-content-between">
        <div class="c3-flex ion-align-items-center">
          <ion-icon slot="start" size="large" [src]="TP_SECTIONS_INFO['operations'].icon | getIcon"></ion-icon>

          <ion-title>{{TP_SECTIONS_INFO['operations'].label}}</ion-title>
        </div>

        <ion-button
          *ngIf="hasOperations"
          color="primary"
          (click)="openCreateDialog()"
          fill="solid"
        >
          <span class="ion-hide-md-down">Aggiungi Operazione</span>
          <ion-icon slot="end" [src]="'plus' | getIcon"></ion-icon>
        </ion-button>
      </div>
    </ion-toolbar>

  </ion-card-header> 

  <ion-card-content>
    <div *ngIf="loading$ | async">
      <ion-grid>
        <ion-row class="ion-align-items-center">
          <ion-col size="12" class="c3-flex ion-justify-content-center ion-align-items-center">
            <ion-spinner color="secondary"></ion-spinner>
          </ion-col>
          <ion-col size="12" class="ion-text-center">
            <span>Caricamento in corso...</span>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div config-description *ngIf="!(loading$ | async)">
      <p>{{TP_SECTIONS_INFO['operations'].description}}</p>
      <div class="app-margin-divider"></div>

      <ag-grid-angular c3DarkTable class="c3-table-with-clickable-rows" *ngIf="columnDefs && filteredOperationsList?.length > 0"
        [rowData]="filteredOperationsList" [columnDefs]="columnDefs" [gridOptions]="customAgGridOptions">
      </ag-grid-angular>

      <ion-grid *ngIf="!filteredOperationsList || filteredOperationsList.length === 0">
        <ion-row>
          <ion-col size="auto">
          
               <app-hint-msg size="small">
                Nessuna operazione associata.
              </app-hint-msg>

          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-card-content> 
</ion-card>

<ng-template #actionsCellTmpl let-data>
  <ion-buttons>
    <ion-button (click)="openEditDialog(data?.data, 'delete')" c3Tooltip="Elimina" color="danger">
      <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
    </ion-button>

    <ion-button (click)="openEditDialog(data?.data)" c3Tooltip="Modifica/Aggiungi">
      <ion-icon slot="icon-only" color="primary"  [src]="'pencil' | getIcon"></ion-icon>
    </ion-button>
    
    </ion-buttons>
</ng-template>